export default "__VITE_ASSET__CwdHsLsz__"